import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";
import SkipLink from "@/components/SkipLink";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Routes, Route } from "react-router-dom";
import Index from "@/pages/Index";
import Aanbod from "@/pages/Aanbod";
import SummerRead from "@/pages/SummerRead";
import Over from "@/pages/Over";
import Contact from "@/pages/Contact";
import LeergangOnderstroom from "@/pages/LeergangOnderstroom";
import Organisatieopstellingen from "@/pages/Organisatieopstellingen";
import OrganisatieopstellingenNoordHolland from "@/pages/OrganisatieopstellingenNoordHolland";
import Teamcoaching from "@/pages/Teamcoaching";
import Opleidingstrajecten from "@/pages/Opleidingstrajecten";
import FamilieOpstelling from "@/pages/FamilieOpstelling";
import EenOpEen from "@/pages/EenOpEen";
import Themadag from "@/pages/Themadag";
import Agenda from "@/pages/Agenda";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import MijnStrippenkaart from "@/pages/MijnStrippenkaart";
import KoopStrippenkaart from "@/pages/KoopStrippenkaart";
import Admin from "@/pages/Admin";
import AlgemeneVoorwaarden from "@/pages/AlgemeneVoorwaarden";
import PrivacyEnCookies from "@/pages/PrivacyEnCookies";
import NotFound from "@/pages/NotFound";

/**
 * Router-mounted shell (use with BrowserRouter or MemoryRouter).
 */
const RoutedApp = () => (
  <AuthProvider>
    <SkipLink />
    <ScrollToTop />
    <Navigation />
    <main id="main-content" tabIndex={-1} className="pt-16">
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/aanbod" element={<Aanbod />} />
        <Route path="/summer-read" element={<SummerRead />} />
        <Route path="/leergang-onderstroom" element={<LeergangOnderstroom />} />
        <Route path="/organisatieopstellingen" element={<Organisatieopstellingen />} />
        <Route
          path="/organisatieopstellingen-noord-holland"
          element={<OrganisatieopstellingenNoordHolland />}
        />
        <Route path="/teamcoaching" element={<Teamcoaching />} />
        <Route path="/opleidingstrajecten" element={<Opleidingstrajecten />} />
        <Route path="/familieopstellingen" element={<FamilieOpstelling />} />
        <Route path="/1-op-1" element={<EenOpEen />} />
        <Route path="/over" element={<Over />} />
        <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
        <Route path="/privacy-en-cookies" element={<PrivacyEnCookies />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/koop-strippenkaart" element={<KoopStrippenkaart />} />
        <Route path="/themadag" element={<Themadag />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/mijn-strippenkaart"
          element={
            <ProtectedRoute>
              <MijnStrippenkaart />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
    <Footer />
    <CookieConsent />
  </AuthProvider>
);

export default RoutedApp;
